<template>
  <div class="modal">
    <v-dialog
      :value="value"
      @input="$emit('input')"
      transition="fade-transition"
      content-class="ims-standard-dialog"
    >
      <v-card class="ims-modal-card">
        <v-toolbar elevation="0">
          <v-toolbar-title>
            <!-- Popup header -->
            <h2 id="myModalLabel">View Campaign Brief</h2>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" @click="openAMCCInputsDialog()" color="secondary" v-if="!isClient">
            AM, CC Inputs
          </v-btn>
          <v-btn @click="savePDF()" color="blue-grey" dark>
            <v-icon>get_app</v-icon>Download PDF
          </v-btn>
        </v-toolbar>
        <v-container fluid grid-list-lg class="ims-modal-body">
          <v-layout
            v-for="section in campaignModelSections"
            :name="section.title"
            :key="section.type"
          >
            <v-flex xs12>
              <v-card hover @click.stop="viewComments(section)">
                <v-toolbar dense flat>
                  <v-toolbar-title class="title">{{section.title}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-badge
                    @click.stop="viewComments(section)"
                    :value="section.unreadComments.length"
                    :content="section.unreadComments.length"
                    color="green"
                    overlap
                  >
                    <v-btn>
                      <v-icon :color="section.unreadComments.length == 0 ? 'secondary' : 'red'">chat</v-icon>
                    </v-btn>
                  </v-badge>
                </v-toolbar>
                <v-card-text>
                  <!-- Dynamically generate campaign input fields -->
                  <v-container>
                    <v-layout
                      wrap
                      v-if="
                      (section.type === campaignModelSectionType.CAMPAIGN_SUMMARY) ||
                      (section.type === campaignModelSectionType.INFLUENCER_SELECTION) ||
                      (section.type === campaignModelSectionType.BUDGET_ALLOCATION) ||
                      (section.type === campaignModelSectionType.VIDEO_BRIEF && showVideoBrief)"
                    >
                      <v-flex
                        xs12
                        md6
                        v-for="campaignField in section.content"
                        :key="campaignField.name"
                      >
                        <div v-if="campaignField.type === 'text' && campaignField.name === 'vertical' && !isClient">
                          <label>{{ campaignField.label }}</label>
                          <div>
                            <v-chip
                            v-for="(item, index) in selectedCampaignVertical"
                            :key="index"
                            class="ma-2"                            
                            @click:close="removeChip(index)"
                          >
                            {{item.name}}
                          </v-chip>
                          </div>
                        </div>
                        <div
                          v-else-if="campaign[campaignField.name] && (campaignField.type === 'text' && campaignField.name !== 'vertical') && (campaignField.name !== 'dont' || hideRequiredActions()) && campaign[campaignField.name] !== '' || (campaignField.type === 'slider' && campaign[campaignField.name] !== '')"
                        >
                          <label>{{ campaignField.label }}</label>
                          <p>{{ campaign[campaignField.name] == '' ? '-' : campaign[campaignField.name]}}</p>
                        </div>
                        
                        <div v-if="campaignField.type === 'combobox' && campaign[campaignField.name] && campaign[campaignField.name].length > 0">
                          <label>{{ campaignField.label }}</label>
                          <div v-if="Array.isArray(campaign[campaignField.name]) && campaignField.name !== 'targetLocation'">
                            <v-chip
                              v-for="value in campaign[campaignField.name]"
                              class="ma-2"
                              :key="value"
                            >{{value}}</v-chip>
                          </div>
                          <div v-else-if="Array.isArray(campaign[campaignField.name]) && campaignField.name === 'targetLocation'">
                            <v-chip
                              v-for="value in campaign[campaignField.name]"
                              class="ma-2"
                              :key="value"
                            >{{value}}</v-chip>
                          </div>
                          <div v-else>
                            <p>{{campaign[campaignField.name]}}</p>
                          </div>
                        </div>

                        <div v-if="campaignField.type === 'textarea' && campaign[campaignField.name] !== ''">
                          <div v-if="(campaignField.name !== 'visualMust' 
                          && campaignField.name !== 'copyMust') || hideRequiredActions()">
                            <label>{{ campaignField.label }}</label>
                            <p
                              style="white-space: pre-wrap;"
                            >{{ campaign[campaignField.name] == '' ? '-' : campaign[campaignField.name]}}</p>
                          </div>                         
                        </div>             

                        <div v-if="campaignField.type === 'select' && campaign[campaignField.name] && campaign[campaignField.name] != 'No preference' && (campaignField.name === 'gender' || campaignField.name === 'targetGender' ||  hideRequiredActions())">
                          <label>{{ campaignField.label }}</label>
                          <p v-if="campaignField.name === 'ioNumbers'">{{ (campaign[campaignField.name] ? campaign[campaignField.name] : '-') }}</p>
                          <p v-else-if="campaignField.name === 'name'">{{ (campaign[campaignField.name] ? campaign[campaignField.name] : '-') }} <span v-if="campaign.campaignCode">({{campaign.campaignCode}})</span></p>
                          <p v-else>{{ getDisplayValueFromSelect(campaignField.value, campaign[campaignField.name]) }}</p>
                        </div>

                        <div v-if="campaignField.type === 'autocomplete' && campaign[campaignField.name]">
                          <label>{{ campaignField.label }}</label>
                          <p>{{ getCountryDisplayValueFromSelect(campaignField.value, campaign[campaignField.name]) }}</p>
                        </div>

                        <div
                          v-if="campaignField.type === 'chips' && campaign[campaignField.name]"
                        >
                          <label>{{ campaignField.label }}</label>
                          <div>
                            <v-chip v-for="(item, index) in campaign[campaignField.name]" :key="index"  :value="item"      
                              class="ma-2"                               
                              filter                                                                                                                                                             
                            >
                              {{item}}
                            </v-chip>
                          </div>
                        </div>  

                        <div v-if="campaignField.type === 'date' && campaign[campaignField.name] !== ''">
                          <label>{{ campaignField.label }}</label>
                          <p>{{ campaign[campaignField.name] == '' ? '-' : campaign[campaignField.name]}}</p>
                        </div>

                        <div v-if="campaignField.type == 'upload'">
                          <label>{{ campaignField.label }}</label>
                          <div>
                            <a
                              :href="constructImageURL(campaign[campaignField.name])"
                              target="_blank"
                              class="campaign-image"
                            >
                              <img
                                style="width:100%"
                                :src="constructImageURL(campaign[campaignField.name])"
                              />
                            </a>
                          </div>
                        </div>

                        <div v-if="campaignField.type === 'radio' && (campaignField.name === 'revenueCalculation' && hideRequiredActions()) && campaign[campaignField.name] !== undefined && campaign[campaignField.name] !== ''">
                          <label>{{ campaignField.label }}</label>
                          <!-- <p>{{ campaign[campaignField.name] == '' ? '-' : campaign[campaignField.name]}}</p> -->
                          <p><v-chip>{{ campaign[campaignField.name] === undefined || campaign[campaignField.name] === '' ? 'CONTENT' : campaign[campaignField.name].toUpperCase()}}</v-chip></p>                          
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap v-if="section.type === campaignModelSectionType.CONTENT_ANGLE">
                      <v-flex
                        xs12
                        v-for="campaignField in section.content"
                        :key="campaignField.name"
                      >
                        <div v-if="campaignField.type === 'select' && ((campaignField.name === 'actionRequired_time' 
                        || campaignField.name === 'actionRequired_action' 
                        || campaignField.name === 'actionRequired_receive' 
                        || campaignField.name === 'actionRequired_value') && hideRequiredActions())">
                          <label>{{ campaignField.label }}</label>
                          <p>{{ getDisplayValueFromSelect(campaignField.value, campaign[campaignField.name]) }}</p>
                        </div>
                        <div xs12 v-if="campaignField.type === 'multiple_options'">
                          <div
                            class="form-group col-xs-12 pa-0"
                            v-for="(option, optionIndex) in campaign[campaignField.name]"
                            :key="optionIndex"
                          >
                            <element
                              v-for="optionField in campaignField.template"
                              :key="optionField.name"
                            >
                              <div class="form-group col-xs-12 pa-0 mb-0" v-if="optionField.type == 'text'">
                                <h4 class="mb-1">
                                  <strong>{{ campaign[campaignField.name][optionIndex][optionField.name] ? 'Concept ' + (optionIndex + 1) + ': ' + campaign[campaignField.name][optionIndex][optionField.name] : 'Option ' + (optionIndex + 1) }}</strong>
                                </h4>
                              </div>
                              <div
                                class="form-group col-xs-12 col-sm-12 mb-1 pb-0 pl-0"
                                v-if="optionField.type == 'textarea' && campaign[campaignField.name][optionIndex][optionField.name]"
                              >
                                <label>{{ optionField.label }}</label>
                                <p
                                  style="white-space: pre-line"
                                >{{ !campaign[campaignField.name][optionIndex][optionField.name] ? '-' : campaign[campaignField.name][optionIndex][optionField.name] }}</p>
                              </div>
                              <!-- start multiple formats section -->
                              <div v-if="optionField.type == 'multiple_options'">
                                <div v-for="(secondOption, secondOptionIndex) in campaign[campaignField.name][optionIndex][optionField.name]" :key="secondOptionIndex">
                                  <v-layout wrap class="multiple-format" v-for="(optionField2, optionIndex2) in optionField.template" :key="optionIndex2">
                                    <v-flex
                                      xs6
                                      v-for="(format, i) in optionField2"
                                      :key="i"
                                    >
                                      <div class="form-group col-xs-12" v-if="format.type == 'text' && campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]">
                                        <h4>
                                          <strong>{{ campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] : '-' }}</strong>
                                        </h4>
                                      </div>
                                      <div
                                        class="form-group col-xs-12 pa-0 ma-0"
                                        v-if="format.type == 'textarea' && campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                      >
                                        <label>{{ format.label }}</label>
                                        <p
                                          style="white-space: pre-line"
                                        >{{ !campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? '-' : campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] }}</p>
                                      </div>
                                      <div class="form-group col-xs-12 pa-0 ma-0" v-if="format.type === 'combobox' && Array.isArray(campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) && campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name].length > 0">
                                        <label>{{ format.label }}</label>
                                        <div v-if="Array.isArray(campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name])">
                                          <v-chip
                                            v-for="value in campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                            class="ma-2"
                                            :key="value"
                                          >{{value}}</v-chip>
                                        </div>
                                        <div v-else>
                                          <p>{{!campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name] ? '-' : campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]}}</p>
                                        </div>
                                      </div>
                                      <div
                                        class="form-group col-xs-12 pa-0 ma-0 img-insp-block"
                                        v-if="format.type == 'upload' && Array.isArray(campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]) && campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name].length > 0"
                                      >
                                        <div class="col-12 pl-0">
                                          <label>{{ format.label }}</label>
                                        </div>
                                        <div class="d-flex flex-sm-column flex-column">
                                          <div class="pl-0"
                                          v-for="image in campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                          :key="image">
                                            <!-- <template
                                              v-for="image in campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                            > -->
                                              <a
                                                :href="constructImageURL(image.url)"
                                                target="_blank"
                                                :key="image"
                                                class="campaign-image"
                                                v-if="image.type === 'image'"
                                              >
                                                <img style="width:100%" :src="constructImageURL(image.url)" />
                                              </a>
                                              <a
                                                :href="image.url"
                                                target="_blank"
                                                class="campaign-image"
                                                v-if="image.type === 'link'"
                                                :key="image"
                                              >
                                                <iframe class="media-iframe" width="150px" height="100%" :src="image.url" v-if="checkMediaURL(image.url) === 'drive'" allowFullScreen></iframe>
                                                <p v-else>{{image.url}}</p>
                                              </a>
                                            <!-- </template> -->
                                          </div>
                                        </div>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </div>
                              </div>
                              <!-- end multiple formats section -->
                            </element>
                          </div>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      wrap
                      v-if="section.type === campaignModelSectionType.EVENT_BRIEF && showEventBrief && campaign.eventBrief"
                    >
                      <v-flex
                        xs12
                        v-for="campaignField in section.content"
                        :key="campaignField.name"
                      >
                        <div v-if="campaignField.type === 'textarea'">
                          <v-divider></v-divider>
                          <h4>
                            <strong>{{ campaignField.label }}</strong>
                          </h4>
                          <p
                            style="white-space: pre-wrap;"
                          >{{campaign.eventBrief[campaignField.name]}}</p>
                        </div>

                        <div v-if="campaignField.type === 'multiple_options'">
                          <v-divider></v-divider>
                          <h4>
                            <strong>{{ campaignField.label }}</strong>
                          </h4>
                          <div
                            v-for="(option, optionIndex) in campaign.eventBrief[campaignField.name]"
                            :key="optionIndex"
                          >
                            <v-container>
                              <v-layout wrap>
                                <v-flex
                                  xs12
                                  md3
                                  v-for="(optionField, i) in campaignField.template"
                                  :key="i"
                                >
                                  <div v-if="optionField.type == 'text'">
                                    <label>{{ optionField.label }}</label>
                                    <p>{{campaign.eventBrief[campaignField.name][optionIndex][optionField.name]}}</p>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </div>
                        <div v-if="campaignField.type === 'template'">
                          <v-divider></v-divider>
                          <h4>
                            <strong>{{ campaignField.label }}</strong>
                          </h4>
                          <v-container>
                            <v-layout wrap>
                              <v-flex
                                xs12
                                md4
                                v-for="(templateField, i) in campaignField.template"
                                :key="i"
                              >
                                <div v-if="templateField.type == 'text'">
                                  <label>{{ templateField.label }}</label>
                                  <p>{{campaign.eventBrief[campaignField.name][templateField.name]}}</p>
                                </div>

                                <div v-if="templateField.type === 'radioButton'">
                                  <label>{{ templateField.label }}</label>
                                  <p>{{campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes': 'No'}}</p>
                                </div>

                                <div
                                  v-if="templateField.type === 'date' && templateField.name === 'eventDate'"
                                >
                                  <label>{{ templateField.label }}</label>
                                  <p>{{campaign.eventBrief[campaignField.name][templateField.name]}}</p>
                                </div>

                                <div v-if="templateField.type === 'textarea'">
                                  <label>{{ templateField.label }}</label>
                                  <p
                                    style="white-space: pre-wrap;"
                                  >{{campaign.eventBrief[campaignField.name][templateField.name]}}</p>
                                </div>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs4 v-if="currentSectionSelected !== null">
              <chatbox
                v-show="currentSectionSelected.type === section.type"
                :messages="comments"
                :title="commentTitle"
                @sendMessage="sendComment"
                @reloadMessage="viewComments"
                :readOnly="!isPendingCampaign"
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions class="ims-modal-actions">
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- am, cc inputs modal -->
    <am-cc-inputs-modal
      :campaign="campaignData"
      v-model="amCCInputsDialog"
    />
    <!-- end of am, cc inputs modal -->
  </div>
</template>

<script>
import moment from 'moment';
import campaignConfig from './config';
import campaignAPIs from './campaignAPIs';
import campaignHelper from './campaignHelper';
import chatbox from './chatbox';
import config from '@/config';
import utils from '../../../utils';
import campaignPDF from './campaignPDF'
import AmCcInputsModal from './AmCcInputsModal';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import countries from '../../../../static/sources/countries';
// import * as pdfFonts from './custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)
export default {
  name: 'ViewCampaignModal',
  props: {
    value: Boolean,
    campaignData: Object
  },
  components: {
    AmCcInputsModal,
    chatbox
  },
  data() {
    return {
      campaign: {},
      campaignModelSections: campaignConfig.campaignModelSections,
      comments: [],
      commentTitle: 'Comment list',
      campaignAttribute: '',
      sectionName: '',
      currentSectionSelected: null,
      unreadComments: 0,
      copyrightText: 'All Rights Reserved. © Kobe Global Technologies Pte Ltd',
      campaignModelSectionType: campaignConfig.campaignModelSectionType,
      showBudget: false,
      showVideoBrief: false,
      showEventBrief: false,
      campaignVerticals: [],
      selectedCampaignVertical: [],
      MONTH_FORMAT: 'MMM YYYY',
      amCCInputsDialog: false
    };
  },
  computed: {
    isPendingCampaign: function() {
      return this.campaign.status === config.campaignStatus.PENDING_CLIENT_APPROVAL;
    },
    isClient: function() {
      return config.userRoles.CLIENT === this.currentUserRole;
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    currentUserId: function() {
      return this.$store.state.user.id;
    }
  },
  methods: {
    close() {
      this.$emit('input');
    },
    sendComment: function(comment) {
      var newComment = {
        sectionName: this.sectionName,
        text: comment
      };
      if (!this.isClient) {
        newComment.internal = true
      }
      campaignAPIs
        .createComment(this.campaign.id, newComment)
        .then(comment => {})
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    viewComments: function(section) {
      if (!section && this.currentSectionSelected) {
        section = this.currentSectionSelected;
      } else if (section) {
        this.currentSectionSelected = section;
      } else {
        return;
      }
      let content = section.content;
      let attributes = [];
      let queryType = campaignConfig.queryType.EQUAL;
      let sectionName = section.title;
      if (section.type === this.campaignModelSectionType.INFLUENCER_EXPERIENCE) {
        queryType = campaignConfig.queryType.LIKE;
        attributes = content[0].name;
      } else {
        attributes = content.map(item => {
          return item.name;
        });
      }
      const commentConditions = {
        campaignAttribute: attributes,
        sectionName,
        queryType
      };
      campaignAPIs
        .getComments(this.campaign.id, commentConditions, queryType)
        .then(commentList => {
          this.unreadComments = commentList.length;
          this.comments = commentList.map(comment => {
            var isSelf = false;
            if (this.currentUserRole === config.userRoles.CLIENT) {
              isSelf = comment.createdBy.role === config.userRoles.CLIENT;
            } else {
              isSelf = comment.createdBy.role !== config.userRoles.CLIENT;
            }
            return {
              text: comment.text,
              author: comment.createdBy ? comment.createdBy.name : '',
              createdAt: comment.createdAt,
              self: isSelf
            };
          });
          let unreadCommentIds = section.unreadComments.map(item => {
            return item.id;
          });
          section.unreadComments = [];
          if (unreadCommentIds.length > 0) {
            this.markCommentAsRead(unreadCommentIds);
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
      this.commentTitle = section.title;
      this.sectionName = sectionName;
      return false;
    },

    markCommentAsRead: function(commentIds) {
      campaignAPIs
        .markCommentAsRead(commentIds)
        .then(response => {})
        .catch(error => console.error(error));
    },

    getUnreadComments: function() {
      campaignAPIs
        .getUnreadComments(this.campaign.id)
        .then(response => {
          this.detectSection(response);
        })
        .catch(error => {
          console.error(error);
        });
    },

    // figure out which section does comment belongs to
    detectSection: function(comments) {
      this.campaignModelSections.forEach(campaignModel => {
        campaignModel.unreadComments = [];
        for (let comment of comments) {
          if (comment.sectionName && comment.sectionName === campaignModel.title) {
            campaignModel.unreadComments.push(comment);
          } else {
            let template =
              campaignModel.title === this.campaignModelSectionType.INFLUENCER_EXPERIENCE
                ? campaignModel.content[0].template
                : campaignModel.content;
            template.forEach(content => {
              if (
                comment.campaignAttribute &&
                (content.name === comment.campaignAttribute || comment.campaignAttribute.includes(content.name))
              ) {
                campaignModel.unreadComments.push(comment);
              }
            });
          }
        }
      });
    },
    constructImageURL: function(imageName) {
      return utils.func.constructImageURL(imageName);
    },
    getDisplayValueFromSelect: function(selectList, value) {
      var selectedOption = selectList.find(option => {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    },
    getCountryDisplayValueFromSelect: function(selectList, value) {
      let countryLists = Object.assign([], countries)
      if (typeof value === 'string') return value
      var selectedOption = countryLists.filter(option => {
        return value.includes(option.code)
      });
      return selectedOption ? selectedOption.map(o => o.name).join(', ') : '-';
    },
    // convert to base64 dataURL
    toDataURL: url =>
      fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        ),
    savePDF: function() {
      this.doc = {}
      this.doc = campaignPDF.convertPDFLayout(this.campaignModelSections, this.campaignData, this.showBudget, this.copyrightText)
      let vm = this
      setTimeout(function() {
        // let fonts = {
        //   NotoSans: {
        //     normal: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-400-normal.ttf',
        //     bold: 'https://cdn.jsdelivr.net/fontsource/fonts/noto-sans-sc@latest/chinese-simplified-700-normal.ttf'
        //   }
        // };
        pdfMake.fonts = {
          Arial: {
            normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
            bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
          }
        }
        pdfMake.createPdf(vm.doc).download(`${vm.campaignData.name}.pdf`);
      }, 1000)
    },
    // convertPDFLayout: function() {
    //   this.doc = {};
    //   this.doc = {
    //     footer: function(currentPage, pageCount) {
    //       return {
    //         margin: 10,
    //         columns: [
    //           {
    //             fontSize: 9,
    //             text: [
    //               {
    //                 text: '--------------------------------------------------------------------------' +
    //                 '\n',
    //                 margin: [0, 20]
    //               },
    //               {
    //                 text: currentPage.toString() + ' of ' + pageCount
    //               }
    //             ],
    //             alignment: 'center'
    //           }
    //         ]
    //       };
    //       // return currentPage.toString() + ' of ' + pageCount;
    //     },
    //     content: [
    //       {
    //         image: config.kobeLogoDataURL,
    //         width: 60,
    //         style: 'logo'
    //       }
    //     ],
    //     styles: {
    //       header: {
    //         fontSize: 20,
    //         bold: true
    //       },
    //       footer: {
    //         alignment: 'center'
    //       },
    //       sectionTitle: {
    //         alignment: 'center',
    //         bold: true,
    //         fontSize: 18,
    //         marginTop: 20,
    //         // marginLeft: 9,
    //         marginBottom: 7,
    //         padding: 5
    //       },
    //       options: {
    //         alignment: 'left',
    //         bold: true,
    //         fontSize: 15,
    //         marginLeft: 13
    //       },
    //       logo: {
    //         alignment: 'center',
    //         marginBottom: 0
    //       },
    //       attributesTitle: {
    //         fontSize: 13,
    //         bold: true,
    //         // marginLeft: 15,
    //         marginBottom: 4
    //         // decoration: 'underline'
    //       },
    //       attributes: {
    //         // marginLeft: 15,
    //         marginBottom: 7,
    //         fontSize: 11
    //       },
    //       SmallBottomAttributes: {
    //         marginBottom: 3,
    //         fontSize: 11
    //       },
    //       customTitle: {
    //         marginLeft: 13
    //       },
    //       exportTime: {
    //         fontSize: 9,
    //         alignment: 'center',
    //         color: '#A9A9A9'
    //       },
    //       copyright: {
    //         fontSize: 12,
    //         color: '#808080',
    //         marginTop: 20
    //       },
    //       image: {
    //         marginBottom: 15,
    //         maxWidth: 200
    //       },
    //       canvasImage: {
    //         alignment: 'left'
    //       },
    //       kicLabel: {
    //         marginTop: 20,
    //         alignment: 'center'
    //       },
    //       top1: {
    //         marginTop: 0
    //       },
    //       sampleImage: {
    //         marginBottom: 10
    //       },
    //       spacingBottom: {
    //         marginBottom: 10
    //       }
    //     },
    //     defaultStyle: {
    //       font: 'Barlow'
    //     }
    //   };
    //   /**
    //    * Nyein - commented out some codes to roll-back single view if needed
    //    */
    //   // let kicImage = [];
    //   let sectionsColumns = { columns: [] };
    //   for (const item of this.campaignModelSections) {
    //     // loop according to campaign Model Sections from the config
    //     if (item.type === this.campaignModelSectionType.BILLING_DETAILS) {
    //       if (this.showBudget) {
    //         // show or hide Billing Details Title
    //         this.doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
    //       }
    //     } else {
    //       if (item.type === this.campaignModelSectionType.CONTENT_ANGLE || item.type === this.campaignModelSectionType.INFLUENCER_SELECTION) {
    //         this.doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle', pageBreak: 'before' });
    //       } else {
    //         this.doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
    //       }
    //     }
    //     for (const field of item.content) {
    //       // for each section
    //       if (field.name === 'gender') {
    //         // for gender case extract the Gender Text
    //         let genderText = this.getDisplayValueFromSelect(field.value, this.campaignData[field.name]);
    //         let attributeLists = {
    //           type: 'none',
    //           ul: []
    //         }
    //         attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //         attributeLists.ul.push({ text: genderText + '\n\n', style: 'attributes' })
    //         sectionsColumns.columns.push(attributeLists)
    //         // sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
    //         // sectionsColumns.columns.push({ text: genderText + '\n\n', style: 'attributes' });
    //       } else if (field.name === 'budget') {
    //         if (this.showBudget) {
    //           let attributeLists = {
    //             type: 'none',
    //             ul: []
    //           }
    //           attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //           attributeLists.ul.push({ text: `${this.campaignData[field.name]}\n\n`, style: 'attributes' })
    //           sectionsColumns.columns.push(attributeLists)
    //           // sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
    //           // sectionsColumns.columns.push({ text: `${this.campaignData[field.name]}\n\n`, style: 'attributes' });
    //         }
    //       } else if (
    //         field.name === 'actionRequired_time' ||
    //         field.name === 'actionRequired_action' ||
    //         field.name === 'actionRequired_receive' ||
    //         field.name === 'actionRequired_value'
    //       ) {
    //         // Nyein - commented out to remove (can rollback if needed)
    //         // Hide action Required fields in PDF
    //         // if (this.hideRequiredActions()) {
    //         //   let actionRequiredText = this.getDisplayValueFromSelect(field.value, this.campaignData[field.name])
    //         //   let attributeLists = {
    //         //     type: 'none',
    //         //     ul: []
    //         //   }
    //         //   attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //         //   attributeLists.ul.push({ text: actionRequiredText + '\n', style: 'attributes' })
    //         //   sectionsColumns.columns.push(attributeLists);
    //         //   // sectionsColumns.columns.push({text: field.label, style: 'attributesTitle'})
    //         //   // sectionsColumns.columns.push({text: actionRequiredText + '\n\n', style: 'attributes'})
    //         // }
    //       } else if (field.name === 'angles') {
    //         // for influencer Experiences section
    //         let count = 0;
    //         for (let experiences of this.campaign[field.name]) {
    //           let optionColumns = {
    //             columns: []
    //           };
    //           for (let exp in experiences) {
    //             if (exp === 'option_name') {
    //               // construct Option Title
    //               // count = count + 1
    //               let optionTitle = field.label + ' ' + ++count;
    //               this.doc.content.push({ text: `${optionTitle}: ${experiences[exp]}\n\n`, style: 'options' });
    //               // add context manually to fix old data
    //               if (experiences['context']) {
    //                 let attributeLists = {
    //                   type: 'none',
    //                   ul: []
    //                 }
    //                 attributeLists.ul.push({ text: 'Campaign Context', style: 'attributesTitle' })
    //                 attributeLists.ul.push({ text: experiences['context'] + '\n\n\n', style: 'attributes' })
    //                 this.doc.content.push(attributeLists)
    //               }
    //             }
    //             let experiencesTemplate = field.template;
    //             // Nyein - commented out to remove (can rollback if needed)
    //             // let imageList = {
    //             //   color: 'blue',
    //             //   ul: []
    //             // };
    //             // if (exp === 'sample_images') {
    //             //   // for Image Case
    //             //   optionColumns.columns.push({ text: 'Image Inspirations' + '\n\n', style: 'attributesTitle' });
    //             //   for (let image of experiences[exp]) {
    //             //     let url = this.constructImageURL(image);
    //             //     this.toDataURL(url).then(dataURL => {
    //             //       imageList.ul.push({ image: dataURL, width: 200, style: 'image' });
    //             //     });
    //             //   }
    //             //   optionColumns.columns.push(imageList);
    //             //   this.doc.content.push(optionColumns);
    //             //   optionColumns = { columns: [] };
    //             // }
    //             // if (exp === 'formats') {
    //             //   // for multiple formats
    //             //   for(const exp2 of experiences[exp]) {
    //             //     let otherExperiences = experiencesTemplate.filter(expTmp2 => expTmp2.name === exp);
    //             //     for (const otherExp of otherExperiences) {
    //             //       optionColumns.columns.push({ text: otherExp.label, style: 'attributesTitle' });
    //             //       optionColumns.columns.push({ text: experiences[exp] + '\n\n', style: 'attributes' });
    //             //     }
    //             //     if (exp2 === 'sample_images') {
    //             //       // for Image Case
    //             //       optionColumns.columns.push({ text: 'Image Inspirations' + '\n\n', style: 'attributesTitle' });
    //             //       for (let image of experiences[exp]) {
    //             //         let url = this.constructImageURL(image);
    //             //         this.toDataURL(url).then(dataURL => {
    //             //           imageList.ul.push({ image: dataURL, width: 200, style: 'image' });
    //             //         });
    //             //       }
    //             //       optionColumns.columns.push(imageList);
    //             //       this.doc.content.push(optionColumns);
    //             //       optionColumns = { columns: [] };
    //             //     }
    //             //   }
    //             // } else {
    //             let otherExperiences = experiencesTemplate.filter(expTmp2 => expTmp2.name === exp);
    //             for (const otherExp of otherExperiences) {
    //               if (otherExp.name === 'formats') {
    //                 for (let formatIndex in experiences[exp]) { // loop formats
    //                   // optionColumns.columns.push({ text: '\n' + `Angle ${parseInt(formatIndex) + 1}` + '\n', style: ['attributesTitle', 'customTitle'] });
    //                   // this.doc.content.push(optionColumns);
    //                   optionColumns = { columns: [] };
    //                   for (let exp2 in experiences[exp][formatIndex]) { // loop format fields
    //                     let experiencesTemplate2 = otherExp.template[0];
    //                     let otherExperiences2 = experiencesTemplate2.filter(expTmp2 => expTmp2.name === exp2);
    //                     for (const otherExp2 of otherExperiences2) {
    //                       if (otherExp2.name === 'sample_images') {
    //                         // for Image Case
    //                         optionColumns = { columns: [] };
    //                         optionColumns.columns.push({ text: 'Image Inspirations', style: ['attributesTitle', 'customTitle'] });
    //                         this.doc.content.push(optionColumns);
    //                         optionColumns = { columns: [] };
    //                         let attributeLists = {
    //                           type: 'none',
    //                           ul: []
    //                         }
    //                         // attributeLists.ul.push({ text: 'Image Inspirations', style: ['attributesTitle'] })
    //                         // let imageList = {
    //                         //   type: 'none',
    //                         //   color: 'blue',
    //                         //   ul: []
    //                         // };
    //                         for (let image of experiences[exp][formatIndex][exp2]) { // loop sample images
    //                           if (image.type === 'image' && this.checkIfImage(image.url)) {
    //                             let url = this.constructImageURL(image.url);
    //                             this.toDataURL(url).then(dataURL => {
    //                               attributeLists.ul.push({ image: dataURL, width: 200, style: ['sampleImage'] });
    //                             });
    //                           } else {
    //                             attributeLists.ul.push({ text: image.url, style: 'sampleImage', link: this.constructImageURL(image.url) });
    //                           }
    //                         }
    //                         // attributeLists.ul.push(imageList)
    //                         optionColumns.columns.push(attributeLists)
    //                         this.doc.content.push(optionColumns);
    //                         optionColumns = { columns: [] };
    //                         optionColumns.columns.push({ text: '', style: ['spacingBottom'] });
    //                         this.doc.content.push(optionColumns);
    //                         optionColumns = { columns: [] };
    //                       } else {
    //                         let attributeLists = {
    //                           type: 'none',
    //                           ul: []
    //                         }
    //                         attributeLists.ul.push({ text: otherExp2.label, style: 'attributesTitle' })
    //                         if (otherExp2.name === 'mandatory') {
    //                           attributeLists.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'SmallBottomAttributes' })
    //                         } else if (otherExp2.name === 'content_angle') {
    //                           attributeLists.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'SmallBottomAttributes' })
    //                         } else {
    //                           attributeLists.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'attributes' })
    //                         }
    //                         optionColumns.columns.push(attributeLists);
    //                         this.doc.content.push(optionColumns);
    //                         // optionColumns.columns.push({ text: otherExp2.label, style: 'attributesTitle' });
    //                         // optionColumns.columns.push({ text: experiences[exp][formatIndex][exp2] + '\n\n', style: 'attributes' });
    //                       }
    //                       this.doc.content.push(optionColumns);
    //                       if (optionColumns.columns.length > 1) {
    //                         optionColumns = { columns: [] };
    //                       }
    //                     }
    //                   }
    //                   this.doc.content.push({ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510 - 10, y2: 10, lineWidth: 0.01, lineColor: '#e1e1e1' }] });
    //                   this.doc.content.push({ text: '\n' });
    //                 }
    //               } else {
    //                 if (exp !== 'option_name' && exp !== 'context') { // option_name, context are added manually at top
    //                   let attributeLists = {
    //                     type: 'none',
    //                     ul: []
    //                   }
    //                   attributeLists.ul.push({ text: otherExp.label, style: 'attributesTitle' })
    //                   attributeLists.ul.push({ text: experiences[exp] + '\n\n', style: 'attributes' })
    //                   // if (exp === 'context') {
    //                   //   attributeLists.ul.push({ text: experiences[exp] + '\n\n\n', style: 'attributes' })
    //                   // } else {
    //                   //   attributeLists.ul.push({ text: experiences[exp] + '\n\n', style: 'attributes' })
    //                   // }
    //                   optionColumns.columns.push(attributeLists)
    //                   // optionColumns.columns.push({ text: otherExp.label, style: 'attributesTitle' });
    //                   // optionColumns.columns.push({ text: experiences[exp] + '\n\n', style: 'attributes' });
    //                 }
    //               }
    //               this.doc.content.push(optionColumns);
    //               optionColumns = { columns: [] };
    //             }
    //             // }
    //           }
    //         }
    //       } else if (field.name === 'kic') {
    //         if (this.campaignData[field.name] !== '' && typeof this.campaignData[field.name] === 'string') {
    //           sectionsColumns = { columns: [] };
    //           let attributeLists = {
    //             type: 'none',
    //             ul: []
    //           }
    //           let url = this.constructImageURL(this.campaignData[field.name]);
    //           this.toDataURL(url).then(dataURL => {
    //             attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //             attributeLists.ul.push({ image: dataURL, width: 300, style: 'canvasImage', link: url })
    //             // kicImage.push({ text: field.label, style: 'kicLabel' });
    //             // kicImage.push({ image: dataURL, width: 400, style: 'canvasImage', link: url });
    //           });
    //           sectionsColumns.columns.push(attributeLists);
    //         }
    //       } else if (field.name === 'vertical') {
    //         // Nyein - commented out to remove (can rollback if needed)
    //         // if (!this.isClient) {
    //         //   let attributeLists = {
    //         //     type: 'none',
    //         //     ul: []
    //         //   }
    //         //   attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //         //   // sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
    //         //   let verticalNames = this.selectedCampaignVertical.map(v => v.name)
    //         //   attributeLists.ul.push({ text: `${verticalNames.join(', ')}\n\n`, style: 'attributes' })
    //         //   sectionsColumns.columns.push(attributeLists);
    //         //   // sectionsColumns.columns.push({ text: `${verticalNames.join(', ')}\n\n`, style: 'attributes' });
    //         // }
    //       } else {
    //         if (field.name === 'campaignType' ||
    //         field.name === 'dont' ||
    //         field.name === 'visualMust' ||
    //         field.name === 'copyMust' ||
    //         field.name === 'campaignBackground' ||
    //         field.name === 'ioNumbers') {
    //           // Nyein - commented out to remove (can rollback if needed)
    //           // if (this.hideRequiredActions()) {
    //           //   let attributeLists = {
    //           //     type: 'none',
    //           //     ul: []
    //           //   }
    //           //   attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //           //   attributeLists.ul.push({ text: `${this.campaignData[field.name]}\n\n`, style: 'attributes' })
    //           //   sectionsColumns.columns.push(attributeLists);
    //           //   // sectionsColumns.columns.push({ text: `${this.campaignData[field.name]}\n\n`, style: 'attributes' });
    //           // } else {
    //           //   sectionsColumns = { columns: [] };
    //           // }
    //         } else {
    //           let addAttribute = true
    //           if (field.name === 'engagement') {
    //             if (this.campaignData[field.name] <= 0) {
    //               addAttribute = false
    //             }
    //           } else if (field.name === 'revenueCalculation') {
    //             addAttribute = false
    //           } else if (field.name === 'segment') {
    //             if (!this.campaignData[field.name]) {
    //               this.campaignData['segment'] = '-'
    //             }
    //           }
    //           if (addAttribute) {
    //             let attributeLists = {
    //               type: 'none',
    //               ul: []
    //             }
    //             attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
    //             attributeLists.ul.push({ text: `${this.campaignData[field.name]}\n\n`, style: 'attributes' })
    //             sectionsColumns.columns.push(attributeLists);
    //             // sectionsColumns.columns.push({ text: `${this.campaignData[field.name]}\n\n`, style: 'attributes' });
    //           }
    //         }
    //       }
    //       // if (field.name === 'kic') {
    //       //   console.log(sectionsColumns, 'for kic')
    //       // }
    //       this.doc.content.push(sectionsColumns);
    //       if (sectionsColumns.columns.length > 1) {
    //       // to show two columns in a row
    //         sectionsColumns = { columns: [] };
    //       }
    //     }
    //     sectionsColumns = { columns: [] };
    //   }
    //   // this.doc.content.push(kicImage);
    //   this.doc.content.push({ text: this.copyrightText, alignment: 'center', style: 'copyright' });
    //   this.doc.content.push({ text: 'Generated at: ' + moment().format('MMMM Do YYYY, h:mm:ss a'), style: 'exportTime' });
    // },
    // checkIfImage(url) {
    //   const images = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG']
    //   let isImage = false
    //   images.map(img => {
    //     if (url.endsWith(img)) {
    //       isImage = true
    //     }
    //   })
    //   return isImage
    // },
    // hide the required Actions for client
    hideRequiredActions: function() {
      return config.userRoles.CLIENT !== this.currentUserRole;
    },
    getAngleFormat() {
      return Object.assign({}, {
        required_action: '',
        image_angle: '',
        content_angle: '',
        sample_images: ''
      })
    },
    checkMediaURL(url) {
      if (url.includes('drive.google.com')) { // for google drive link, replace the actual link with preview
        return 'drive'
      }
      return 'link'
    },
    openAMCCInputsDialog() {
      // open am, cc inputs dialog
      this.amCCInputsDialog = true
    }
  },
  watch: {
    campaignData: function(newCampaignData) {
      if (!newCampaignData.id) return;
      newCampaignData.angles = campaignHelper.fixAnglesData(newCampaignData.angles)
      if (newCampaignData.goal && Array.isArray(newCampaignData.goal)) {
        newCampaignData.goal = newCampaignData.goal.join(',')
      }
      // newCampaignData.angles = newCampaignData.angles.map(angle => {
      //   const cpAngle = Object.assign({}, angle);
      //   //  restructure array for multiple options, formats & to fit with old data
      //   if (cpAngle.required_action) {
      //     cpAngle.formats = []
      //     let format = this.getAngleFormat()
      //     format.required_action = cpAngle.required_action
      //     format.image_angle = cpAngle.image_angle
      //     format.content_angle = cpAngle.content_angle
      //     const sampleImages = angle.sample_images ? angle.sample_images : [];
      //     if (cpAngle.sample_image) {
      //       sampleImages.push({type: 'image', url: cpAngle.sample_image});
      //     }
      //     format.sample_images = sampleImages
      //     delete cpAngle.required_action;
      //     delete cpAngle.image_angle;
      //     delete cpAngle.content_angle;
      //     delete cpAngle.sample_images;
      //     delete cpAngle.sample_image;
      //     cpAngle.formats.push(format)
      //   }
      //   // fix sample images old data
      //   cpAngle.formats = cpAngle.formats.map(formatOne => {
      //     if (formatOne.sample_images) {
      //       formatOne.sample_images = formatOne.sample_images.map(sampleImage => {
      //         if (!sampleImage.type) {
      //           if (this.checkIfImage(sampleImage)) {
      //             sampleImage = { type: 'image', url: sampleImage };
      //           } else {
      //             sampleImage = { type: 'link', url: sampleImage };
      //           }
      //         }
      //         return sampleImage
      //       })
      //     }
      //     return formatOne;
      //   })
      //   return cpAngle;
      // });
      if (newCampaignData.min_influencer || newCampaignData.max_influencer) {
        /*
          old campaigns formats use 'min_influencer' & 'max_influencer' in database
          so, we override with new attributes for view
        */
        newCampaignData.min_content = newCampaignData.min_influencer;
        newCampaignData.max_content = newCampaignData.max_influencer;
        delete newCampaignData.min_influencer;
        delete newCampaignData.max_influencer;
      }

      // To be Compatible with old campaign data
      this.showBudget = newCampaignData.settings ? newCampaignData.settings.showBudgetToClient : newCampaignData.showBudgetToClient;
      this.showVideoBrief = newCampaignData.settings ? newCampaignData.settings.enableVideoBrief : newCampaignData.enableVideoBrief;
      this.showEventBrief = newCampaignData.settings ? newCampaignData.settings.enableEventBrief : newCampaignData.enableEventBrief;
      this.campaignModelSections = campaignConfig.campaignModelSections;
      // remove Video Brief section if it is null
      if (!this.showVideoBrief) {
        let array = this.campaignModelSections.filter(sections => sections.type !== campaignConfig.campaignModelSectionType.VIDEO_BRIEF);
        this.campaignModelSections = array;
      }
      // remove Event Brief section if it is null
      if (!this.showEventBrief) {
        let array = this.campaignModelSections.filter(sections => sections.type !== campaignConfig.campaignModelSectionType.EVENT_BRIEF);
        this.campaignModelSections = array;
      }
      // delete budget label and values for clients view
      if (!this.showBudget && config.userRoles.CLIENT === this.currentUserRole) {
        let sections = this.campaignModelSections;
        let filteredContent;
        sections.forEach((section, index) => {
          if (section.type === this.campaignModelSectionType.BUDGET_ALLOCATION) {
            filteredContent = section.content.filter(field => field.name !== 'budget');
            this.campaignModelSections[index].content = filteredContent;
          }
        });
        delete this.campaignData.budget;
      }
      newCampaignData.startDate = moment(newCampaignData.startDate).format(this.MONTH_FORMAT);
      newCampaignData.endDate = moment(newCampaignData.endDate).format(this.MONTH_FORMAT);
      this.campaign = newCampaignData;
      this.comments = [];
      this.commentTitle = 'Comment list';
      this.campaignAttribute = '';

      // get unread comments
      this.getUnreadComments();

      // Get all campaign verticals and add to selected campaign verticals array
      campaignAPIs
        .getAllCampaignVerticals(false)
        .then(response => {
          this.campaignVerticals = response.data;
          this.selectedCampaignVertical = [];
          if (newCampaignData.vertical) {
            this.campaignVerticals.map(item => {
              newCampaignData.vertical.map(verticalId => {
                if (item.id === verticalId) {
                  this.selectedCampaignVertical.push(item)
                }
              })
            })
          }
        })
        .catch(error => {
          console.log('error', error);
        });

      // Reset the chat box
      this.currentSectionSelected = null;
      setTimeout(() => {
        // Find all the .divFlex <div>
        const divFlexs = document.querySelectorAll('.flex');
        // Loop through them...
        for (let divFlex of divFlexs) {
          // ...checking if each has an empty
          if (divFlex.textContent.trim() === '') {
            // If it does, add to to the <div> the class .is-empty
            divFlex.classList.add('is-empty');
          }
        }
      }, 100)
    }
  },
  beforeUpdate: function() {
    this.doc = campaignPDF.convertPDFLayout(this.campaignModelSections, this.campaignData, this.showBudget, this.copyrightText)
  }
};
</script>
<style lang="scss" scoped>
.campaign-image {
  display: inline-block;
  max-width: 150px;
  margin-right: 10px;
  margin-bottom: 10px;
  img {
    max-width: 100%;
  }
}
.multiple-format {
  padding-top: 20px;
  border-bottom: 1px solid #e1e1e1;
}
.is-empty {
  display: none;
}

@media only screen and (min-width: 1268px) {
  .img-insp-block {
    width:60%
  }
}
</style>



// WEBPACK FOOTER //
// ViewCampaignModal.vue?2e14b63e